/**
 * AreaList
 */

import React, { useRef, useState } from "react";
import { AreaPageLink, IImage } from "types/global";
import AreaStatusLink from "components/AreaStatusLink";
import { useOutsideClick } from "hooks/useOutsideClick";

interface Props {
    /** AreaList heading */
    heading: string;

    /** Valid until text */
    validUntilText: string;

    /** Valid to date */
    validToDate?: string;

    /** Areapagelist SubforecastHeading */
    areaPageLinksSubForecastText?: string;
    /** Array of area page links */
    areaPageLinks: AreaPageLink[];
}

/** AreaList component listing area pages. */
const AreaList: React.FC<Props> = ({
    heading,
    validUntilText,
    validToDate,
    areaPageLinksSubForecastText,
    areaPageLinks,
}) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const listRef = useRef<HTMLUListElement>(null);
    useOutsideClick(listRef, () => setOpenIndex(null));
  
    return (
        <section
            aria-labelledby="area-list-heading"
            className="w-full lg:w-auto p-8 lg:p-0 ml-0 mt-8 lg:mt-0"
        >
            <h2
                id="area-list-heading"
                className="text-h3 font-bold lg:text-h2 text-black"
            >
                {heading}
            </h2>

            <div className="flex items-center mb-2">
                <p className="text-h4 font-medium text-orange mr-6">
                    {validUntilText}
                </p>
                <p className="text-h4 text-darker">{validToDate}</p>
            </div>

            {areaPageLinks && (
                <ul ref={listRef}>
                    {areaPageLinks.map((link: any, index: number) => (
                        <AreaStatusLink
                            {...link}
                            isOpen={openIndex === index}
                            key={index}
                            index={index}
                            className={"bg-grey-lighter"}
                            areaPageLinksSubForecastText={areaPageLinksSubForecastText}
                            onToggle={() =>
                                setOpenIndex(openIndex === index ? null : index)
                            }
                        />
                    ))}
                </ul>
            )}
        </section>
    );
};

export default AreaList;
